import type {
  SellerTransactionListItem,
  SellerTransactionStatus,
} from "@/lib/api/types";

/** "All" sentinel for the single-select status / provider filters. */
export const TRANSACTION_FILTER_ALL = "all";

export type TransactionStatusFilter =
  | typeof TRANSACTION_FILTER_ALL
  | SellerTransactionStatus;

/** Provider filter values are gateway slugs; `all` clears the filter. */
export type TransactionProviderFilter = string;

/** The full filter state the page owns and the toolbar/drawer edit. */
export type TransactionFiltersState = {
  status: TransactionStatusFilter;
  provider: TransactionProviderFilter;
  /** `yyyy-mm-dd` from `<input type="date">`; empty string = unset. */
  from: string;
  to: string;
  search: string;
};

export type TransactionFiltersProps = {
  value: TransactionFiltersState;
  onChange: (next: TransactionFiltersState) => void;
  onReset: () => void;
  /** Count of filters set beyond the defaults — drives the mobile badge. */
  activeCount: number;
};

export type TransactionsListProps = {
  items: SellerTransactionListItem[];
  locale: string;
  /** Builds the seller route for an order, so the Order cell can link out. */
  orderHref: (orderId: string) => string;
  onOpenTransaction: (transactionId: string) => void;
};
